import { Navigate, Route, Routes } from 'react-router-dom'
import { SessionBootstrapper } from '@/components/SessionBootstrapper'
import { AppShell } from '@/components/layout/AppShell'
import { AuthShell } from '@/components/layout/AuthShell'
import { ProtectedRoute } from '@/components/layout/ProtectedRoute'
import LoginPage from '@/pages/auth/LoginPage'
import RegisterPage from '@/pages/auth/RegisterPage'
import DashboardPage from '@/pages/DashboardPage'
import SkillsListPage from '@/pages/skills/SkillsListPage'
import NewSkillPage from '@/pages/skills/NewSkillPage'
import SkillDetailPage from '@/pages/skills/SkillDetailPage'
import MarketplacePage from '@/pages/marketplace/MarketplacePage'
import MarketplaceDetailPage from '@/pages/marketplace/MarketplaceDetailPage'
import AdminDashboardPage from '@/pages/admin/AdminDashboardPage'
import AdminUsersPage from '@/pages/admin/AdminUsersPage'
import AdminWorkspacesPage from '@/pages/admin/AdminWorkspacesPage'
import AdminAuditPage from '@/pages/admin/AdminAuditPage'
import WorkspacePage from '@/pages/settings/WorkspacePage'
import PrivacyPage from '@/pages/settings/PrivacyPage'
import InvitePage from '@/pages/InvitePage'

export default function App() {
  return (
    <SessionBootstrapper>
      <Routes>
        {/* Auth shell */}
        <Route element={<AuthShell />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/invite/:token" element={<InvitePage />} />
        </Route>

        {/* Protected app shell */}
        <Route
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />

          <Route path="/skills" element={<SkillsListPage />} />
          <Route path="/skills/new" element={<NewSkillPage />} />
          <Route path="/skills/:id" element={<SkillDetailPage />} />

          <Route path="/marketplace" element={<MarketplacePage />} />
          <Route path="/marketplace/:id" element={<MarketplaceDetailPage />} />

          <Route
            path="/settings/workspace"
            element={
              <ProtectedRoute requireOwner>
                <WorkspacePage />
              </ProtectedRoute>
            }
          />
          <Route path="/settings/privacy" element={<PrivacyPage />} />

          <Route
            path="/admin"
            element={
              <ProtectedRoute requireSuperadmin>
                <AdminDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute requireSuperadmin>
                <AdminUsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/workspaces"
            element={
              <ProtectedRoute requireSuperadmin>
                <AdminWorkspacesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/audit"
            element={
              <ProtectedRoute requireSuperadmin>
                <AdminAuditPage />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </SessionBootstrapper>
  )
}
